<div class="services">
  <div class="container">
    <h1>{{ "LOGIN.LOGIN_SERVICE.OUR_SERVICES" | translate }}</h1>
    <div class="horizontal-border"></div>
    <!--   <h2>{{ "LOGIN.LOGIN_SERVICE.WHOLESALE" | translate }}</h2> -->
    <div class="row" style="max-width: 1200px">
      <div
        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
        style="margin-bottom: 20px"
        *ngFor="let service of services"
      >
        <app-index-service-card [data]="service"></app-index-service-card>
      </div>
      <div
      class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
      *ngFor="let serv of servicesRes"
      style="margin-bottom: 20px"
    >
      <app-index-service-card [data]="serv"></app-index-service-card>
    </div>
      <!--      <div class="col-md-7 col-lg-7" style="margin-bottom: 20px; max-width: 815px">-->
      <!--        <app-index-service-card [data]="lastService"></app-index-service-card>-->
      <!--      </div>-->
      <!--      <div class="col-md-4 col-lg-4" [style]="_translate.currentLang == 'en' ? 'line-height:1.2' : 'line-height:1.5' "-->
      <!--           style="margin-bottom: 20px; max-width: 400px">-->
      <!--        <app-index-service-card [data]="beforeLastService"></app-index-service-card>-->
      <!--      </div>-->
    </div>
    <!--    <h2 class="restaurant-text">{{'LOGIN.LOGIN_SERVICE.RESTAURANTS' | translate}}</h2> -->
      <!--      <div class="col-12 last" style="margin-bottom: 20px;">-->
      <!--        <app-index-service-card [data]="lastResService"></app-index-service-card>-->
      <!--      </div>-->
  </div>
</div>

<app-testimonials></app-testimonials>
<app-offer></app-offer>
<app-features></app-features>
<app-ai-section></app-ai-section>
<app-industries></app-industries>
<app-certifications></app-certifications>
<app-consulting></app-consulting>

<h2 class="header2">{{ "ARTICLES.TITLE" | translate }}</h2>
<div class="row articlesSection" #scrollMe id="articlesSection">
  <owl-carousel-o
    class="customSlider row"
    [style.direction]="('dir' | translate) === 'rtl' ? 'ltr' : 'ltr'"
    [options]="customOptions"
  >
    <ng-template carouselSlide *ngFor="let article of articles">
      <div
        [dir]="_translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
        class="articleCard"
        [routerLink]="'article/' + article.id"
      >
        <img
          [src]="
            article.smallImagePath
              ? baseImageUrl + article.smallImagePath
              : './assets/images/user.png'
          "
          onerror="this.src='./assets/images/user.png'"
          alt=""
        />
        <div class="break_line"></div>
        <p class="serviceTitle">{{ article.name | translate }}</p>
        <!--        <p class="serviceDescription">{{article.description | translate | truncate:[250, "..."]}}</p>-->
      </div>
    </ng-template>
  </owl-carousel-o>
  <!--  <div class="row" style="padding: 20px">-->
  <!--    <div *ngFor="let article of articles" class="col-sm-12 col-md-3 articleCard"  [routerLink]="'article/' + article.id">-->
  <!--<div style="height: 90%">-->
  <!--  <img             [src]="article.smallImagePath? baseImageUrl+article.smallImagePath :'./assets/images/user.png'"-->
  <!--                   onerror="this.src='./assets/images/user.png'" alt="">-->
  <!--</div>-->
  <!--      <p class="cardTitle">{{article.name}}</p>-->
  <!--    </div>-->
  <!--  </div>-->
</div>
